<template>
  <div class="accardion-content accardion-content-active">
    <div class="policy-accardion-items-header" :class="productType === 'pf' ? 'jcc' : ''">
      <div class="policy-accardion-items-title" :class="productType === 'pf' ? 'w50' : 'w40'">Название</div>
      <div class="policy-accardion-items-title" :class="productType === 'pf' ? 'w50' : 'w30'">Страховая сумма</div>
      <div v-show="productType !== 'pf'" class="policy-accardion-items-title" style="width: 30%;">Страховая премия</div>
    </div>
    <div v-for="(group, key) in risksComputed" :key="key">
      <div class="policy-accardion-items-row" v-for="(subgroup,key) in group" :key="key">
        {{ key }}
        <div class="policy-accardion-items-row-item" v-for="(risk, key) in subgroup" :key="key">
          <div class="policy-accardion-items-text" :class="productType === 'pf' ? 'w50' : 'w40'">
            {{ risk.name }}
          </div>
          <div
            v-if="typeof risk.premium_p === 'undefined' || !project_visible"
            class="policy-accardion-items-text" :class="productType === 'pf' ? 'w50 tac' : 'w30'"
          >
            {{ risk.amount }}
          </div>
          <div v-if="typeof risk.amount_p !== 'undefined' && project_visible" class="policy-accardion-items-text"
               style="width: 30%;">
            {{ risk.amount_p }}
          </div>
          <div v-if="(typeof risk.premium_p === 'undefined' || !project_visible) && productType !== 'pf'"
               class="policy-accardion-items-text" style="width: 30%;">
            {{ risk.premium }}
          </div>
          <div v-if="typeof risk.premium_p !== 'undefined' && project_visible" class="policy-accardion-items-text"
               style="width: 30%;">
            {{ risk.premium_p }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupedRisksComponent",
  props: ["risks", "project_visible", "project_state", "productType"],
  computed: {
    risksComputed() {
      const result = this.risks;
      if (this.productType === "pf") { // продукт Инвестор / ПИФ (ДСЖ)
        delete result.hidden;
        return result;
      } else {
        return result;
      }
    }
  }
};
</script>

<style scoped>
.jcc {
  justify-content: center !important;
}

.w30 {
  width: 30% !important;
}

.w40 {
  width: 40% !important;
}

.w50 {
  width: 50% !important;
}

.tac {
  text-align: center !important;
}

</style>